export default __webpack_public_path__ + "static/gs-R-code--mobile-118aaac20b21dcfcd4c30b42fc59b0a2.png";